import React from "react";

type RiotBarState = {
  riotBarReady: boolean;
  onRiotBarLoad: () => void;
};

const RiotBarContext = React.createContext<RiotBarState>({} as RiotBarState);

export const useRiotBar = () => React.useContext(RiotBarContext);

export type RiotBarProviderProps = {
  children: React.ReactNode;
};

export const RiotBarProvider = ({ children }: RiotBarProviderProps) => {
  const [riotBarReady, setRiotBarReady] = React.useState(false);

  const onRiotBarLoad = React.useCallback(() => {
    setRiotBarReady(true);
  }, []);

  return (
    <RiotBarContext.Provider
      value={{
        riotBarReady,
        onRiotBarLoad,
      }}
    >
      {children}
    </RiotBarContext.Provider>
  );
};
